import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/main.scss";
import "./styles/themes.scss";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.css";
import "./locale/i18n/i18n.ts";
import { router } from "./routes/router";
import { RouterProvider } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ToastContainer } from "react-toastify";
import AntdLocaleProvider from "./components/AntdLocaleProvider";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

root.render(
  <div>
    <AntdLocaleProvider>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router}></RouterProvider>
        <ToastContainer position="top-center" />
      </QueryClientProvider>
    </AntdLocaleProvider>
  </div>
);
